<template>
    <div class="page__loading">
        <van-loading size="30px" text-size="24px" text-color="#fff" vertical>加载中...</van-loading>
    </div>
</template>

<script>
import Vue from 'vue'
import {Loading} from 'vant';

Vue.use(Loading);

export default {
    
}
</script>

<style lang="scss" scoped>
.page__loading{
    position: fixed;
    z-index: 9999;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>